import type { PaletteOptions } from "@material-ui/core/styles/createPalette";
import { createTheme } from "@material-ui/core";

import type { TypographyOptions } from "@material-ui/core/styles/createTypography";
import { getComponentOverrides } from "./themeOverrides";
import { getDefaultComponentProps } from "./themeProps";

const basePalette: PaletteOptions = {
    type: "light",
    primary: {
        main: "#008fed",
        dark: "#00347d",
        light: "#85d4fa",
    },
    text: {
        disabled: "rgba(0, 0, 0, 0.20)",
    },
};

const baseTypography: TypographyOptions = {
    htmlFontSize: 10,
    button: {
        letterSpacing: 0.8,
        textTransform: "none",
    },
};

const baseTheme = createTheme({
    palette: basePalette,
    typography: baseTypography,
});

export const theme = createTheme({
    palette: basePalette,
    typography: {
        ...baseTypography,
        h1: {
            fontSize: "3.4rem",
            fontWeight: 300,
        },
        h2: {
            fontSize: "2.4rem",
            fontWeight: 300,
        },
        h3: {
            fontSize: "2.0rem",
            fontWeight: 300,
        },
        h4: {
            fontSize: "1.6rem",
            fontWeight: 300,
        },
        h5: {
            fontSize: "1.4rem",
        },
        h6: {
            fontSize: "1.3rem",
        },
        body2: {
            color: baseTheme.palette.text.secondary,
        },
    },
    overrides: getComponentOverrides(baseTheme),
    props: getDefaultComponentProps(),
});
